import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ChangeDoorModeComponent } from './change-door-mode.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { TranslateModule } from '@ngx-translate/core';
import { LocalizationService } from 'src/app/shared/services/localization.service';

@NgModule({
  declarations: [ChangeDoorModeComponent],
  imports: [CommonModule, FormsModule, MatFormFieldModule, ReactiveFormsModule, TranslateModule],
  exports: [ChangeDoorModeComponent],
  providers: [
    LocalizationService,
    TranslateModule
  ],
})
export class ChangeDoorModeModule {}
